import type { SelectChangeEvent } from '@mui/material';
import { MenuItem, Select } from '@mui/material';

export enum IncludingParam {
  none = 'None',
  values = 'Values',
  revenue = 'Revenue',
  valuesAndRevenue = 'Values & Revenue',
}

const ITEMS: Record<IncludingParam, string> = {
  [IncludingParam.none]: 'None',
  [IncludingParam.values]: 'Values',
  [IncludingParam.revenue]: 'Revenue',
  [IncludingParam.valuesAndRevenue]: 'Values & Revenue',
};

interface Props {
  value: IncludingParam;
  onChange: (value: IncludingParam) => void;
}

export function IncludingParamSelect({ value, onChange }: Props) {
  const handleChange = (event: SelectChangeEvent<IncludingParam>) => {
    onChange(event.target.value as IncludingParam);
  };

  return (
    <Select sx={{ width: 160 }} value={value} onChange={handleChange}>
      {Object.entries(ITEMS).map(([value, label]) => {
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
}
